module.exports = __webpack_public_path__ + "static/img/m_role.303e161.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/wxsjglm/m_role.png
// module id = uVZg
// module chunks = 7